import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ConstElement extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event) {
        if (typeof this.props.onElementChange === 'function') {
            this.props.onElementChange(event);
        }
    }
    render() {
        if (this.props.element === 'gender') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'gender', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: ''}, "選択してください"),
                    React.createElement("option", {value: 1}, "男性"),
                    React.createElement("option", {value: 2}, "女性")
                    );
        }
        if (this.props.element === 'status') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'status', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: null}, "選択してください"),
                    React.createElement("option", {value: 0}, "未承認"),
                    React.createElement("option", {value: 1}, "承認"),
                    React.createElement("option", {value: 9}, "否認"),
                    );
        }
        if (this.props.element === 'method_interview') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'method_interview', value: this.props.value, className: 'form-control'},
                        React.createElement("option", {value: null}, "選択してください"),
                        React.createElement("option", {value: 'LINE'}, "LINE"),
                        React.createElement("option", {value: 'facetime'}, "FaceTime"),
                    );
        }
        if (this.props.element === 'time_interview') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'time_interview', value: this.props.value, className: 'form-control'},
                        React.createElement("option", {value: null}, "選択してください"),
                        React.createElement("option", {value: 1}, "10〜12時"),
                        React.createElement("option", {value: 2}, "12〜14時"),
                        React.createElement("option", {value: 3}, "14〜16時"),
                        React.createElement("option", {value: 4}, "16〜18時"),
                    );
        }
        if (this.props.element === 'reject_reason') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'reject_reason', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: -1}, "選択してください"),
                    React.createElement("option", {value: 1}, "入力項目不備"),
                    React.createElement("option", {value: 2}, "不適切")
                    );
        }

        if (this.props.element === 'jobs.status') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'status', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 'NULL'}, "掲載確認中"),
                    React.createElement("option", {value: 1}, "掲載中"),
                    React.createElement("option", {value: 2}, "掲載終了"),
                    React.createElement("option", {value: 3}, "就業中"),
                    React.createElement("option", {value: 4}, "評価待ち"),
                    React.createElement("option", {value: 5}, "作業完了"),
                    React.createElement("option", {value: 6}, "未採用"),
                    React.createElement("option", {value: 7}, "仲裁"),
                    React.createElement("option", {value: 8}, "欠勤"),
                    React.createElement("option", {value: 9}, "依頼キャンセル"),
                    );
        }
        if (this.props.element === 'ticket_request.status') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'status', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 0}, "承認待ち"),
                    React.createElement("option", {value: 1}, "支払い待ち"),
                    React.createElement("option", {value: 2}, "予定"),
                    React.createElement("option", {value: 3}, "評価待ち"),
                    React.createElement("option", {value: 4}, "評価完了"),
                    React.createElement("option", {value: 5}, "見送り"),
                    React.createElement("option", {value: 6}, "キャンセル"),
                    );
        }
        if (this.props.element === 'ticket.status') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: this.props.name, value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 0}, "非公開"),
                    React.createElement("option", {value: 1}, "公開"),
                    );
        }

        if (this.props.element === 'jobs.bill_flag') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'bill_flag', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 0}, "未請求"),
                    React.createElement("option", {value: 1}, "請求済"),
                    );
        }

        if (this.props.element === 'jobs.work_request_flag') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'work_request_flag', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: -1}, "なし"),
                    React.createElement("option", {value: 1}, "あり"),
                    );
        }

        if (this.props.element === 'jobs.trouble_kb') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'trouble_kb', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 'NULL'}, "トラブルなし"),
                    React.createElement("option", {value: 1}, "個人への返金あり"),
                    React.createElement("option", {value: 2}, "法人に付与したポイント消去"),
                    React.createElement("option", {value: 3}, "依頼者とワーカーのトラブル、依頼者にポイント戻し"),
                    React.createElement("option", {value: 4}, "依頼者（法人）とワーカーとのトラブルあり、依頼者にポイント戻し"),
                    React.createElement("option", {value: 5}, "依頼者とワーカーとのトラブルがあり、ワーカーにポイント付与"),
                    React.createElement("option", {value: 6}, "依頼者（法人）とワーカーとのトラブルがあり、ワーカーにポイント付与"),
                    React.createElement("option", {value: 7}, "依頼者とワーカーとのトラブルがあり、依頼者にポイントを戻すと同時にワーカーにポイント付与"),
                    React.createElement("option", {value: 8}, "依頼者（法人）とワーカーとのトラブルがあり、依頼者にポイントを戻すと同時にワーカーにポイント付与"),
                    );
        }

        if (this.props.element === 'jobs.work_start_time') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'work_start_time', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
                React.createElement("option", {value: "23:59"}, "23:59"),
            );
        }

        if (this.props.element === 'jobs.work_start_time_houjin') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'work_start_time', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
            );
        }

        if (this.props.element === 'jobs.work_end_time') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'work_end_time', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
                React.createElement("option", {value: "23:59"}, "23:59"),
            );
        }
        if (this.props.element === 'jobs.post_period_start_time') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'post_period_start_time', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
            );
        }
        if (this.props.element === 'jobs.post_period_end_time') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'post_period_end_time', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
            );
        }

        if (this.props.element === 'job_applys.status') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'status', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                    React.createElement("option", {value: 'NULL'}, "未決定"),
                    React.createElement("option", {value: 1, disabled: (this.props.staff_count <= this.props.recruit_count && this.props.current_status != 1) ? "disabled" : ''}, "採用"),
                    React.createElement("option", {value: 3}, "欠勤"),
                    React.createElement("option", {value: 2}, "不採用"),
                    React.createElement("option", {value: 9}, "応募キャンセル"),
                    );
        }

        if (this.props.element === 'job_applys.complete_flag') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'complete_flag', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                    React.createElement("option", {value: 'NULL'}, "未決定"),
                    React.createElement("option", {value: 1}, "完了"),
                    React.createElement("option", {value: 9}, "未完了"),
                    );
        }

        if (this.props.element === 'job_applys.work_result') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'work_result', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                    React.createElement("option", {value: 'NULL'}, "未決定"),
                    React.createElement("option", {value: 1}, "通常勤務"),
                    React.createElement("option", {value: 2}, "残業"),
                    React.createElement("option", {value: 7}, "遅刻"),
                    React.createElement("option", {value: 8}, "早退"),
                    React.createElement("option", {value: 9}, "欠勤"),
                    );
        }

        if (this.props.element === 'job_applys.evaluation_client') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'evaluation_client', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                    React.createElement("option", {value: 'NULL'}, "未決定"),
                    React.createElement("option", {value: 1}, "★"),
                    React.createElement("option", {value: 2}, "★★"),
                    React.createElement("option", {value: 3}, "★★★"),
                    React.createElement("option", {value: 4}, "★★★★"),
                    React.createElement("option", {value: 5}, "★★★★★"),
                    );
        }

        if (this.props.element === 'job_applys.evaluation_staff') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'evaluation_staff', value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                    React.createElement("option", {value: 'NULL'}, "未決定"),
                    React.createElement("option", {value: 1}, "★"),
                    React.createElement("option", {value: 2}, "★★"),
                    React.createElement("option", {value: 3}, "★★★"),
                    React.createElement("option", {value: 4}, "★★★★"),
                    React.createElement("option", {value: 5}, "★★★★★"),
                    );
        }

        if (this.props.element === 'anti_check') {
            return React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'anti_check', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 0}, "未対応"),
                    React.createElement("option", {value: 9}, "問題なし"),
                    React.createElement("option", {value: 1}, "問題あり")
                    );
        }

        if (this.props.element === 'clients.bill_flag') {
                return this.props.value == 1 ?
                    React.createElement(
                        'select',
                        {onChange: this.handleChange, name: 'bill_flag', value: this.props.value, className: 'form-control'},
                        React.createElement("option", {value: 1}, "請求書払い"),
                    ) :
                    React.createElement(
                        'select',
                        {onChange: this.handleChange, name: 'bill_flag', value: this.props.value, className: 'form-control'},
                        React.createElement("option", {value: null}, "選択してください"),
                        React.createElement("option", {value: 1}, "請求書払い"),
                    )
        }

        if (this.props.element === 'clients.invoice_date') {
            return  React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'invoice_date', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: null}, "選択してください"),
                    React.createElement("option", {value: 5}, "5"),
                    React.createElement("option", {value: 6}, "6"),
                    React.createElement("option", {value: 7}, "7"),
                    React.createElement("option", {value: 8}, "8"),
                    React.createElement("option", {value: 9}, "9"),
                    React.createElement("option", {value: 10}, "10"),
                    React.createElement("option", {value: 11}, "11"),
                    React.createElement("option", {value: 12}, "12"),
                    React.createElement("option", {value: 13}, "13"),
                    React.createElement("option", {value: 14}, "14"),
                    React.createElement("option", {value: 15}, "15"),
                )
        }

        if (this.props.element === 'clients.regist_reason') {
            return  React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'regist_reason', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: null}, "選択してください"),
                    React.createElement("option", {value: 1}, "新聞・雑誌の記事"),
                    React.createElement("option", {value: 2}, "インターネット広告"),
                    React.createElement("option", {value: 3}, "その他広告"),
                    React.createElement("option", {value: 4}, "検索サイト"),
                    React.createElement("option", {value: 9}, "CM"),
                    React.createElement("option", {value: 5}, "知人の紹介※"),
                    React.createElement("option", {value: 6}, "営業※"),
                    React.createElement("option", {value: 7}, "すでにエントリーと取引を行っている"),
                    React.createElement("option", {value: 8}, "その他※"),
                )
        }

        if (this.props.element === 'clients.payment_period') {
            return  React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'payment_period', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: null}, "選択してください"),
                    React.createElement("option", {value: 1}, "当月"),
                    React.createElement("option", {value: 2}, "翌月"),
                    React.createElement("option", {value: 3}, "翌々月"),
                )
        }
        if (this.props.element === 'clients.houjin_status') {
            return  React.createElement(
                    'select',
                    {onChange: this.handleChange, name: 'houjin_status', value: this.props.value, className: 'form-control'},
                    React.createElement("option", {value: 0}, "未承認"),
                    React.createElement("option", {value: 1}, "承認"),
                )
        }

        if (this.props.element === 'mails.destination') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'destination', value: this.props.value, className: 'form-control', disabled: this.props.disabled == 1 ? 'disabled' : ''},
                React.createElement("option", {value: ''}, "選択してください"),
                React.createElement("option", {value: 1}, "全シェアジョブ ユーザー(承認者のみ)"),
                React.createElement("option", {value: 2}, "全ワーカー(承認者のみ) "),
                React.createElement("option", {value: 3}, "全依頼者(承認者のみ)"),
                React.createElement("option", {value: 4}, "全依頼者・法人(承認者のみ)"),
                React.createElement("option", {value: 5}, "テストメール配信(エントリーのみ) "),
                React.createElement("option", {value: 6}, "依頼者個別配信"),
                React.createElement("option", {value: 7}, "ワーカー個別配信"),
            );
        }

        if (this.props.element === 'mails.status') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'status', value: this.props.value, className: 'form-control'},
                React.createElement("option", {value: ''}, "選択してください"),
                React.createElement("option", {value: 0}, "未配信"),
                React.createElement("option", {value: 1}, "配信済"),
            );
        }

        if (this.props.element === 'mails.type') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'type', value: this.props.value, className: 'form-control', disabled: this.props.disabled == 1 ? 'disabled' : ''},
                React.createElement("option", {value: ''}, "選択してください"),
                React.createElement("option", {value: 1}, "メール配信"),
            );
        }

        if (this.props.element === 'staff_total') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'staff_total', value: this.props.value, className: 'form-control'},
                React.createElement("option", {value: 1000}, "¥1,000"),
                React.createElement("option", {value: 1500}, "¥1,500"),
                React.createElement("option", {value: 2000}, "¥2,000"),
                React.createElement("option", {value: 2500}, "¥2,500"),
                React.createElement("option", {value: 3000}, "¥3,000"),
                React.createElement("option", {value: 3500}, "¥3,500"),
                React.createElement("option", {value: 4000}, "¥4,000"),
                React.createElement("option", {value: 4500}, "¥4,500"),
                React.createElement("option", {value: 5000}, "¥5,000"),
                React.createElement("option", {value: 5500}, "¥5,500"),
                React.createElement("option", {value: 6000}, "¥6,000"),
                React.createElement("option", {value: 6500}, "¥6,500"),
                React.createElement("option", {value: 7000}, "¥7,000"),
                React.createElement("option", {value: 7500}, "¥7,500"),
                React.createElement("option", {value: 8000}, "¥8,000"),
                React.createElement("option", {value: 8500}, "¥8,500"),
                React.createElement("option", {value: 9000}, "¥9,000"),
                React.createElement("option", {value: 9500}, "¥9,500"),
                React.createElement("option", {value: 10000}, "¥10,000"),
                React.createElement("option", {value: 12000}, "¥12,000"),
                React.createElement("option", {value: 14000}, "¥14,000"),
                React.createElement("option", {value: 16000}, "¥16,000"),
                React.createElement("option", {value: 18000}, "¥18,000"),
                React.createElement("option", {value: 20000}, "¥20,000"),
                React.createElement("option", {value: 22000}, "¥22,000"),
                React.createElement("option", {value: 24000}, "¥24,000"),
                React.createElement("option", {value: 26000}, "¥26,000"),
                React.createElement("option", {value: 28000}, "¥28,000"),
                React.createElement("option", {value: 30000}, "¥30,000"),
                React.createElement("option", {value: 32000}, "¥32,000"),
                React.createElement("option", {value: 34000}, "¥34,000"),
                React.createElement("option", {value: 36000}, "¥36,000"),
                React.createElement("option", {value: 38000}, "¥38,000"),
                React.createElement("option", {value: 40000}, "¥40,000"),
                React.createElement("option", {value: 42000}, "¥42,000"),
                React.createElement("option", {value: 44000}, "¥44,000"),
                React.createElement("option", {value: 46000}, "¥46,000"),
                React.createElement("option", {value: 48000}, "¥48,000"),
                React.createElement("option", {value: 50000}, "¥50,000"),
            );
        }

        if (this.props.element === 'confirmed_at') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'confirmed_at', value: this.props.value, className: 'form-control'},
                React.createElement("option", {value: ''}, "未認証"),
                React.createElement("option", {value: 1}, "認証済"),
            );
        }

        if (this.props.element === 'jobs.web_show_flag') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: 'web_show_flag', value: this.props.value, className: 'form-control'},
                React.createElement("option", {value: 0}, "掲載しない"),
                React.createElement("option", {value: 1}, "掲載する"),
            );
        }
        if (this.props.element === 'helper.work_start') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name: this.props.name, value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
            );
        }
        if (this.props.element === 'helper.work_end') {
            return React.createElement(
                'select',
                {onChange: this.handleChange, name:  this.props.name, value: this.props.value, className: 'form-control', disabled: this.props.is_disabled},
                React.createElement("option", {value: "00:00"}, "00:00"),
                React.createElement("option", {value: "00:30"}, "00:30"),
                React.createElement("option", {value: "01:00"}, "01:00"),
                React.createElement("option", {value: "01:30"}, "01:30"),
                React.createElement("option", {value: "02:00"}, "02:00"),
                React.createElement("option", {value: "02:30"}, "02:30"),
                React.createElement("option", {value: "03:00"}, "03:00"),
                React.createElement("option", {value: "03:30"}, "03:30"),
                React.createElement("option", {value: "04:00"}, "04:00"),
                React.createElement("option", {value: "04:30"}, "04:30"),
                React.createElement("option", {value: "05:00"}, "05:00"),
                React.createElement("option", {value: "05:30"}, "05:30"),
                React.createElement("option", {value: "06:00"}, "06:00"),
                React.createElement("option", {value: "06:30"}, "06:30"),
                React.createElement("option", {value: "07:00"}, "07:00"),
                React.createElement("option", {value: "07:30"}, "07:30"),
                React.createElement("option", {value: "08:00"}, "08:00"),
                React.createElement("option", {value: "08:30"}, "08:30"),
                React.createElement("option", {value: "09:00"}, "09:00"),
                React.createElement("option", {value: "09:30"}, "09:30"),
                React.createElement("option", {value: "10:00"}, "10:00"),
                React.createElement("option", {value: "10:30"}, "10:30"),
                React.createElement("option", {value: "11:00"}, "11:00"),
                React.createElement("option", {value: "11:30"}, "11:30"),
                React.createElement("option", {value: "12:00"}, "12:00"),
                React.createElement("option", {value: "12:30"}, "12:30"),
                React.createElement("option", {value: "13:00"}, "13:00"),
                React.createElement("option", {value: "13:30"}, "13:30"),
                React.createElement("option", {value: "14:00"}, "14:00"),
                React.createElement("option", {value: "14:30"}, "14:30"),
                React.createElement("option", {value: "15:00"}, "15:00"),
                React.createElement("option", {value: "15:30"}, "15:30"),
                React.createElement("option", {value: "16:00"}, "16:00"),
                React.createElement("option", {value: "16:30"}, "16:30"),
                React.createElement("option", {value: "17:00"}, "17:00"),
                React.createElement("option", {value: "17:30"}, "17:30"),
                React.createElement("option", {value: "18:00"}, "18:00"),
                React.createElement("option", {value: "18:30"}, "18:30"),
                React.createElement("option", {value: "19:00"}, "19:00"),
                React.createElement("option", {value: "19:30"}, "19:30"),
                React.createElement("option", {value: "20:00"}, "20:00"),
                React.createElement("option", {value: "20:30"}, "20:30"),
                React.createElement("option", {value: "21:00"}, "21:00"),
                React.createElement("option", {value: "21:30"}, "21:30"),
                React.createElement("option", {value: "22:00"}, "22:00"),
                React.createElement("option", {value: "22:30"}, "22:30"),
                React.createElement("option", {value: "23:00"}, "23:00"),
                React.createElement("option", {value: "23:30"}, "23:30"),
            );
        }
        return '';
    }
}
